module.exports = __webpack_public_path__ + "img/WorldBuildingTowerEntranceOpen.16c2b172.png";